import {Configuration} from "../api/client-axios";
import {baseUrl} from "../config/apiConfig";


export const apiConfiguration = () => new Configuration({

    basePath: baseUrl,
    accessToken: `${localStorage.getItem('token')}`});